import ClickToCopy from '../ClickToCopy';
import { APP_ENVIRONMENT, APP_VERSION, BUILD_TIME, shortAppVersion } from '@/config/env';

/**
 * Footer for the Settings page: which build of Mon Ami GO this device is
 * running. The commit is copyable so support can read it back from a user.
 */
export default function BuildInfo() {
  const built = BUILD_TIME ? new Date(BUILD_TIME) : null;
  return (
    <footer className="mt-10 pt-4 border-t border-gray-200 text-xs text-gray-500 flex flex-wrap items-center gap-x-2 gap-y-1" data-testid="build-info">
      <span>Mon Ami GO</span>
      <span aria-hidden="true">·</span>
      <span className="flex items-center gap-1">
        Build <ClickToCopy text={APP_VERSION} displayText={shortAppVersion()} className="font-mono" showIconOnHover={false} />
      </span>
      <span aria-hidden="true">·</span>
      <span>{APP_ENVIRONMENT}</span>
      {built && !Number.isNaN(built.getTime()) && (
        <>
          <span aria-hidden="true">·</span>
          <span>built {built.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}</span>
        </>
      )}
    </footer>
  );
}
